import { useEffect, useState } from "react";
import { templateFieldApi } from "../../../../utilities/api/templateFieldApi";
import { TemplateFields } from "../../../../utilities/enums/TemplateFields";
import { addNotificationItem, removeNotificationItem } from "../../../../features/state/StateNotification-slice";
import { useAppDispatch } from "../../../../app/hooks";

export const useOfficialManagementController = () => {
  const [govNameObj, setGovNameObj] = useState<any>();
  const [agNameObj, setAgNameObj] = useState<any>();
  const [sosNameObj, setSosNameObj] = useState<any>();
  const [fetchingGov, setFetchingGov] = useState<boolean>(false);
  const [fetchingAG, setFetchingAG] = useState<boolean>(false);
  const [fetchingSos, setFetchingSos] = useState<boolean>(false);
  const [editGov, setEditGov] = useState<boolean>(false);
  const [editAG, setEditAG] = useState<boolean>(false);
  const [editSos, setEditSos] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!govNameObj && !fetchingGov) {
      fetchGovernorName();
      setFetchingGov(true);
    }

    if (!agNameObj && !fetchingAG) {
      fetchAGName();
      setFetchingAG(true);
    }

    if(!sosNameObj && !fetchingSos) {
      fetchSosName();
      setFetchingSos(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchGovernorName = async () => {
    let result = await templateFieldApi.getTemplateFieldByName(TemplateFields.GovernorName)
    setGovNameObj(result);
  }

  const fetchAGName = async () => {
    let result = await templateFieldApi.getTemplateFieldByName(TemplateFields.AGName);
    setAgNameObj(result);
  }

  const fetchSosName = async () => {
    let result = await templateFieldApi.getTemplateFieldByName(TemplateFields.SosName);
    setSosNameObj(result);
  }

  const updateGovernorName = () => {
    if (validateField(govNameObj.fieldValue)) {
      templateFieldApi.updateTemplateField(govNameObj);
      setEditGov(!editGov);
    }
  }

  const updateAGName = () => {
    if (validateField(agNameObj.fieldValue)) {
      templateFieldApi.updateTemplateField(agNameObj);
      setEditAG(!editAG);
    }
  }

  const updateSosName = () => {
    if (validateField(sosNameObj.fieldValue)) {
      templateFieldApi.updateTemplateField(sosNameObj);
      setEditSos(!editSos);
    }
  }

  const validateField = (value: string) => {
    if (value !== "") {
      return true;
    }

    dispatch(addNotificationItem({message: "Government Official names may not be updated to an empty value.", type: "error"}));
    setTimeout(() => {
      dispatch(removeNotificationItem());
    }, 5000);
    return false;
  } 

  const toggleEditAG = () => {
    if (editAG) {
      updateAGName();
    }
    else {
      setEditAG(!editAG);
    }
  }

  const toggleEditGov = () => {
    if (editGov) {
      updateGovernorName();
    }
    else {
      setEditGov(!editGov);
    }
  }

  const toggleEditSos = () => {
    if (editSos) {
      updateSosName();
    }
    else {
      setEditSos(!editSos)
    }
  }

  const handleGovNameChange = (e: any) => {
    setGovNameObj({...govNameObj, fieldValue: e.target.value});
  }

  const handleAGNameChange = (e: any) => {
    setAgNameObj({...agNameObj, fieldValue: e.target.value});
  }

  const handleSosNameChange = (e: any) => {
    setSosNameObj({...sosNameObj, fieldValue: e.target.value});
  }

  return {
    toggleEditAG,
    toggleEditGov,
    toggleEditSos,
    handleGovNameChange,
    handleAGNameChange,
    handleSosNameChange,
    agNameObj,
    govNameObj,
    sosNameObj,
    editAG,
    editGov,
    editSos
  };
}